import React from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

import PersonIcon from "@mui/icons-material/Person";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import PinDropIcon from "@mui/icons-material/PinDrop";

import PreferenceAccordion from "../PreferenceAccordion";
import { showError } from "../../../utils/toastUtils";

export default function AdditionalInfoTab({
  sweetRed,
  aboutMe,
  setAboutMe,
  wordCount,
  handleSaveAboutMe,
  preferenceCategories,
  selectedPrefs,
  setSelectedPrefs,
  profile,
  countries,
  regions,
  selectedCountry,
  setSelectedCountry,
  selectedRegion,
  setSelectedRegion, // ✅ ADD THIS LINE
  handleRegionChange,
}) {
  const handleSaveClick = () => {
    if (wordCount < 30 || wordCount > 100) {
      showError("Your description must be between 30 and 100 words.");
      return;
    }

    handleSaveAboutMe();
  };

  return (
    <>
      {/* ================= ABOUT ME ================= */}
      <Typography
        gutterBottom
        sx={{
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          color: sweetRed.main,
        }}
      >
        <PersonIcon sx={{ mr: 1, color: sweetRed.main }} />
        Summary About Myself
      </Typography>

      <Box sx={{ mt: 2 }}>
        <TextField
          label="Tell others about yourself"
          multiline
          minRows={4}
          fullWidth
          value={aboutMe}
          onChange={(e) => setAboutMe(e.target.value)}
          error={wordCount < 30 || wordCount > 100}
        />

        <Box sx={{ mt: 1 }}>
          <Typography
            variant="caption"
            color={
              wordCount < 30 || wordCount > 100 ? "error" : "textSecondary"
            }
          >
            Words: {wordCount} (Min: 30, Max: 100)
          </Typography>
        </Box>
      </Box>

      {/* ================= INTERESTS ================= */}
      <Typography
        gutterBottom
        sx={{
          fontWeight: "bold",
          mt: 2,
          display: "flex",
          alignItems: "center",
          color: sweetRed.main,
        }}
      >
        <FlightTakeoffIcon sx={{ mr: 1 }} />
        My Interests
      </Typography>

      <PreferenceAccordion
        categories={preferenceCategories}
        selectedPrefs={selectedPrefs}
        setSelectedPrefs={setSelectedPrefs}
        preferences={profile.preferences}
      />

      {/* ================= LOCATION ================= */}
      <Typography
        gutterBottom
        sx={{
          fontWeight: "bold",
          mt: 3,
          display: "flex",
          alignItems: "center",
          color: sweetRed.main,
        }}
      >
        <PinDropIcon sx={{ mr: 1 }} />
        Current Location
      </Typography>

      <Grid container spacing={2} sx={{ mt: 0 }}>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>Country</InputLabel>
            <Select
              label="Country"
              value={selectedCountry}
              onChange={(e) => {
                setSelectedCountry(e.target.value);
                setSelectedRegion("");
              }}
            >
              {countries.map(({ isoCode, name, value }) => (
                <MenuItem key={isoCode} value={isoCode}>
                  {name} (+{value})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth disabled={!regions.length}>
            <InputLabel>Region</InputLabel>
            <Select
              label="Region"
              value={selectedRegion}
              onChange={handleRegionChange}
            >
              {regions.map(({ id, name }) => (
                <MenuItem key={id} value={id}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      {/* ================= SAVE ================= */}
      <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="outlined"
          color="error"
          size="small"
          onClick={handleSaveClick}
        >
          Save
        </Button>
      </Box>
    </>
  );
}
